// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_Billing360SubscriptionRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_Billing360SubscriptionRow — live subscription summary for the
 * billing-360 envelope.
 *
 * Fields match franchises_subscriptions + subscription_plans joined data.
 * Datetime fields are ISO-8601 UTC strings (controller converts GMT-3 before
 * fromRow()).
 *
 * can_reconcile (#27): whether staff may trigger manual reconciliation
 * ("sync") for this subscription — derived from PlatformGatewayRegistry
 * + `instanceof ChargeReconciliationGateway` in admin.php::billing_360(),
 * never a hardcoded provider string, so the frontend can gate the button
 * without knowing which providers implement the port.
 */
import { registerContract } from './validate'

export interface Subscriptions_Billing360SubscriptionRow {
subscription_id: number
effective_status?: string
raw_status?: string
plan_id?: number
plan_name?: string
currency?: string
price_cents?: number
provider?: string
paid_through?: string
grace_until?: string
current_period_end?: string
created_at?: string
can_reconcile?: boolean
}

registerContract('Subscriptions_Billing360SubscriptionRow', {
  subscription_id:    { type: 'number',  required: true },
  effective_status:   { type: 'string',  required: false },
  raw_status:         { type: 'string',  required: false },
  plan_id:            { type: 'number',  required: false },
  plan_name:          { type: 'string',  required: false },
  currency:           { type: 'string',  required: false },
  price_cents:        { type: 'number',  required: false },
  provider:           { type: 'string',  required: false },
  paid_through:       { type: 'string',  required: false },
  grace_until:        { type: 'string',  required: false },
  current_period_end: { type: 'string',  required: false },
  created_at:         { type: 'string',  required: false },
  can_reconcile:      { type: 'boolean', required: false },
})
